import styled from 'styled-components';
import Link from 'next/link';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import { textSmall } from 'styles-js/mixins/typography';
export default function SkipFeaturedPostsButton() {
  const onClick = () => trackFootfallEvent(Event.FeaturedPostSkipped);
  return <A href="#responses" onClick={onClick} data-sentry-element="A" data-sentry-component="SkipFeaturedPostsButton" data-sentry-source-file="skipFeaturedPostsButton.tsx">
      {i18n.t('Jump to replies')}
    </A>;
}
const A = styled(Link)`
  ${textSmall}
  color: ${({
  theme
}) => theme.colorTextLight};
`;